module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0043.jpg?v=a563646b";